

import React, { memo, useRef } from 'react';
import cx from 'classnames';
import Button from '../../Button';
import Menu from '../../Menu';
import Icon from '../../Icon';
import Text from '../../Text';

import '../styles/_split-button.scss';

const TYPE_PROPS = {
  PRIMARY: { menuBgClass: 'bg--primary', iconColour: 'white' },
  SECONDARY: { menuBgClass: 'bg--secondary', iconColour: 'white' },
  TERTIARY: { menuBgClass: 'bg--tertiary', iconColour: 'denim' },
  QUATERNARY: { menuBgClass: 'bg--quaternary', iconColour: 'white' },
  QUINARY: { menuBgClass: 'bg--quinary', iconColour: 'white' }
};







const defaultButtonProps = { type: 'SECONDARY' };

function SplitButton({
  primaryButtonText,
  options = [],
  buttonProps = defaultButtonProps,
  onClick
}) {
  const { type = 'SECONDARY' } = buttonProps || {};
  const { menuBgClass, iconColour: typeIconColour } = TYPE_PROPS[type] || TYPE_PROPS.SECONDARY;

  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleMenu = () => {
    if (menuRef.current) {
      menuRef.current.toggleMenu();
    }
  };

  return (
    <div className="split-button">
      <Button {...buttonProps} className="split-button__primary" onClick={onClick}>
        {primaryButtonText}
      </Button>
      <div className="split-button__options">
        <div id="split-button__options">
          <Button
            id="split-button__options"
            className="split-button__custom"
            onClick={toggleMenu}
            ref={buttonRef}
            {...buttonProps}>

            <Icon
              name="arrowdown"
              size={10}
              color={typeIconColour}
              className="split-button__custom--arrowdown" />

          </Button>
        </div>
      </div>
      <Menu
        id="split-button__options-menu"
        className={cx(
          'split-button__options-menu',
          `split-button__options-menu-${menuBgClass}`
        )}
        align="end"
        ref={menuRef}
        buttonId="split-button__options"
        closeAfterClick>

        {options.length && options.map((option) =>
        <Button
          key={option.label}
          {...buttonProps}
          isFullWidth
          onClick={option.onClick}
          disabled={option.disabled}
          role="menuitem">

            <Text darkTheme={type !== 'TERTIARY'}>{option.label}</Text>
          </Button>
        )}
      </Menu>
    </div>);

}

export default memo(SplitButton);